import { render, staticRenderFns } from "./PlotRenditions.vue?vue&type=template&id=f2b4c772&scoped=true&"
import script from "./PlotRenditions.vue?vue&type=script&lang=js&"
export * from "./PlotRenditions.vue?vue&type=script&lang=js&"
import style0 from "./PlotRenditions.vue?vue&type=style&index=0&id=f2b4c772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b4c772",
  null
  
)

export default component.exports